<template>
  <vs-row vs-w="12">
      <GlobalFilters 
        :categories="categories"
        :subCategories="subCategories"
        :selectedCategory="selectedCategory"
        :selectedSubCategory="selectedSubCategory"
        @updateSelectedCategory="selectedCategory = $event"
        @updateSelectedSubCategory="selectedSubCategory = $event"
        :selected="selected"
        @updateFilters="selected = $event"
        :page="'appointment-notes'"
        :urlType="urlType"
      />
      <!-- Chart -->
      <vs-col vs-w="12">        
        <vs-row
          v-if="allTotalCount"
          vs-align="flex-start"
          vs-type="flex"
          vs-justify="right"
          vs-w="12"
        >Total count of appointments: {{ Number.parseFloat(allTotalCount).toFixed(0) }}
        </vs-row>
        <BarChart 
          :chartData="chartData"
          :chartOptions="chartOptions"
        />
      </vs-col>
    </vs-row>
</template>

<script>
import BarChart from '../charts/BarChart.vue';
import GlobalFilters from '../common/GlobalFilters';
import {
  filterCategories,
} from '../common/GlobalFilters/filterConstant.js';
import { mapActions, mapMutations, mapState } from 'vuex';
import helper from '../../../superAdmin/insights/helper';
import { cloneDeep } from 'lodash';

export default {
  components: {
    BarChart,
    GlobalFilters,
  },
  props: {
    tabs: Array,
    isByNurse: Boolean,
  },
  computed: {
    ...mapState('analytics', ['chartData', 'FILTERS_SELECTED']),
    allTotalCount(){      
      let count = 0;
      const chartDataSets = this.chartData.datasets ? this.chartData.datasets[2] : null;
      if(chartDataSets) {
        chartDataSets.data.forEach(val => {
          count += val;
        });
      }

      return count;
    },
  },
  data() {
    return {
      categories: [
        filterCategories.ORGANIZATIONS,
        filterCategories.CLINICS,
        filterCategories.NURSE,
        filterCategories.PATIENTS,
      ],
      selectedCategory: {},
      subCategories: [],
      selectedSubCategory: {},
      selected: {},
      static: {
        temp_brand: [],
      },
      // Chart data
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'top',
            labels: {
              boxWidth: 12,
            },
          },
          title: {
            display: true,
            text: '',
          },
        },
        scales: {
          y: {
            title: {
              display: true,
              text: 'Appointment Notes',
            },
            min: 0,
          },
          x: {
            title: {
              display: true,
              text: this.isByNurse ? 'Nurse' : 'Clinic',
            },
            grid : {
              display : false,
            },
            ticks: {
              font: {
                size: 10,
              },
              maxRotation: 90,
              minRotation: 90,
            },
          },
        },
      },
      urlType: '',
      orgId: '',
    };
  },
  methods:{
    ...mapActions('analytics', ['fetchAppointmentNotes']),
    ...mapMutations('analytics', ['MUTATE_CHART_DATA', 'MUTATE_TABLE_DATA', 'MUTATE_TABLE_HEADERS']),
    fetchAppointmentNotesChartData() {

      let payload = helper.generateAnalyticsAPIParameters(this.selected);
      payload.is_nurse = this.isByNurse;

      if(this.selected.brand && this.selected.brand.length && this.static.temp_brand[0] === 0){
        payload.brand = this.selected.brand;
      } else {
        payload.brand = this.static.temp_brand;
      }

      if (['OrgOwner', 'SuperAdmin'].includes(this.urlType)){
        payload.brand = this.selected.brand;
      }
      if(!['SuperAdmin', 'Supplier'].includes(this.urlType)){
        payload = {
          ...payload,
          org: [this.orgId],
        };
      }
      this.fetchAppointmentNotes(payload).then((res) => {
        this.MUTATE_CHART_DATA(res.data.chartData);
        
        const { labels, datasets } = res.data.chartData;
        const tableData = labels.map((label, index) => {
          return {
            clinic: label,
            with_notes: (datasets[0].data[index]),
            without_notes: (datasets[1].data[index]),
            total: (datasets[2].data[index]),
          };
        });
        this.MUTATE_TABLE_DATA(tableData);
      });
    },
  },
  created() {
    this.selected = cloneDeep(this.FILTERS_SELECTED);
    this.MUTATE_TABLE_DATA([]);
    this.MUTATE_CHART_DATA({});
    this.MUTATE_TABLE_HEADERS([]);
    let userType = JSON.parse(
      localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
    );
    if(userType && userType.userType === 'superAdmin'){
      this.urlType = 'SuperAdmin';
    }else if(userType && userType.organizations[0].role.toUpperCase() === 
    'supplier'.toUpperCase()){
      this.urlType = 'Supplier';
    }else{
      this.urlType = 'OrgOwner';
    }
    if(localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`)){
      this.orgId = localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`);
    }
    if(userType && userType.brands.length){
      this.static.temp_brand = userType.brands;
    } else if(this.urlType == 'Supplier' || this.urlType == 'OrgOwner'){
      this.selected.brand = [];
      this.static.temp_brand[0] = 0;
    }
    this.MUTATE_TABLE_HEADERS([this.isByNurse ? 'Nurse' : 'Clinic', 'With Notes', 'Without Notes', 'Total']);
  },
  watch: {
    selected: {
      handler() {
        this.fetchAppointmentNotesChartData();
      },
      deep: true,
    },
  },
};
</script>

<style ></style>